import { Portfolio } from "../components/Portfolio/Portfolio";

export function Projects() {
  return <Portfolio />;
}
